import React from 'react';
import PropTypes from 'prop-types';
import { CRow, CCol, CFormSwitch, CFormInput, CFormSelect } from '@coreui/react';

const ReportSchedule = ({ config, updateConfig }) => (
  
  <div className="mb-4">
    {/* Ежедневный */}
    <CRow className="align-items-center mb-2 bg-light p-2 rounded border">
      <CCol xs={12} md={4}>
        <CFormSwitch
          id="send_daily"
          label={<span className="fw-bold">Ежедневный отчет</span>}
          checked={config.send_daily_report}
          onChange={(e) => updateConfig({ send_daily_report: e.target.checked })}
        />
      </CCol>
      {config.send_daily_report && (
        <CCol xs={12} md={8} className="d-flex align-items-center mt-2 mt-md-0">
          <span className="small text-muted me-2">Время отправки:</span>
          <CFormInput
            type="time"
            size="sm"
            value={config.daily_report_time || ''}
            onChange={(e) => updateConfig({ daily_report_time: e.target.value })}
            style={{ width: '130px' }}
          />
        </CCol>
      )}
    </CRow>

    {/* Еженедельный */}
    <CRow className="align-items-center mb-2 bg-light p-2 rounded border">
      <CCol xs={12} md={4}>
        <CFormSwitch
          id="send_weekly"
          label={<span className="fw-bold">Еженедельный отчет</span>}
          checked={config.send_weekly_report}
          onChange={(e) => updateConfig({ send_weekly_report: e.target.checked })}
        />
      </CCol>
      {config.send_weekly_report && (
        <CCol xs={12} md={8} className="d-flex align-items-center mt-2 mt-md-0 flex-wrap gap-2">
          <span className="small text-muted">День:</span>
          <CFormSelect
            size="sm"
            value={config.report_day_of_week || 0}
            onChange={(e) => updateConfig({ report_day_of_week: parseInt(e.target.value, 10) })}
            style={{ width: '150px' }}
          >
            <option value="0">Понедельник</option>
            <option value="1">Вторник</option>
            <option value="2">Среда</option>
            <option value="3">Четверг</option>
            <option value="4">Пятница</option>
            <option value="5">Суббота</option>
            <option value="6">Воскресенье</option>
          </CFormSelect>
          <span className="small text-muted">Время:</span>
          <CFormInput
            type="time"
            size="sm"
            value={config.weekly_report_time || ''}
            onChange={(e) => updateConfig({ weekly_report_time: e.target.value })}
            style={{ width: '130px' }}
          />
        </CCol>
      )}
    </CRow>

    {/* Ежемесячный */}
    <CRow className="align-items-center bg-light p-2 rounded border">
      <CCol xs={12} md={4}>
        <CFormSwitch
          id="send_monthly"
          label={<span className="fw-bold">Ежемесячный отчет</span>}
          checked={config.send_monthly_report}
          onChange={(e) => updateConfig({ send_monthly_report: e.target.checked })}
        />
      </CCol>
      {config.send_monthly_report && (
        <CCol xs={12} md={8} className="d-flex align-items-center mt-2 mt-md-0 flex-wrap gap-2">
          <span className="small text-muted">Число:</span>
          <CFormInput
            type="number"
            size="sm"
            min="1"
            max="31"
            value={config.report_day_of_month || 1}
            onChange={(e) => updateConfig({ report_day_of_month: parseInt(e.target.value, 10) })}
            style={{ width: '80px' }}
          />
          <span className="small text-muted">Время:</span>
          <CFormInput
            type="time"
            size="sm"
            value={config.monthly_report_time || ''}
            onChange={(e) => updateConfig({ monthly_report_time: e.target.value })}
            style={{ width: '130px' }}
          />
        </CCol>
      )}
    </CRow>

{/* --- ПОСМЕННЫЙ ОТЧЕТ --- */}
    <CRow className="align-items-center mb-2 bg-light p-2 rounded border border-primary border-opacity-25">
      <CCol xs={12}>
        <CFormSwitch
          id="send_shift"
          label={<span className="fw-bold text-primary">Отчет по сменам (сразу после завершения)</span>}
          checked={config.send_shift_report || false}
          onChange={(e) => updateConfig({ send_shift_report: e.target.checked })}
        />
        <div className="text-muted small mt-1 ms-5">
          Система автоматически определит время окончания смен техники из её настроек и пришлет детальный отчет по каждой смене.
        </div>
        
        {config.send_shift_report && (
          <div className="mt-3 ms-5 p-2 bg-white rounded border border-secondary border-opacity-25 shadow-sm">
            <CFormSwitch
              id="send_shift_wait_data"
              label={<span className="fw-semibold text-dark">Дождаться полной выгрузки данных за смену</span>}
              checked={config.send_shift_wait_data || false}
              onChange={(e) => updateConfig({ send_shift_wait_data: e.target.checked })}
            />
            <div className="text-muted small mt-1">
              Если включено — система подождет загрузки и обработки видео последнего часа работы смены. Если выключено — отчет отправится <b>мгновенно</b> с теми данными, что есть на момент окончания смены по времени.
            </div>
          </div>
        )}
      </CCol>
    </CRow>
      
  </div>
);

ReportSchedule.propTypes = {
  config: PropTypes.object.isRequired,
  updateConfig: PropTypes.func.isRequired,
};

export default ReportSchedule;